module.exports = "/static/Images/en/One.png";